module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mediaMain"
  }, [(_vm.mediaLoading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Auto-Generated Letters")]), _vm._v(" "), _c('div', [_c('v-client-table', {
    attrs: {
      "data": _vm.mediaGridSpec.tableData,
      "columns": _vm.mediaGridSpec.columns,
      "options": _vm.mediaGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "download",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-cloud-download",
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "target": "_blank"
          },
          on: {
            "click": function($event) {
              _vm.mediaDownloadRow(props.row.mediaId, props.row.mediaTypeId, props.row.parentId, props.row.filename)
            }
          }
        })])]
      }
    }, {
      key: "delete",
      fn: function(props) {
        return _vm.isAdmin || _vm.isRCReview ? [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deleteMedia(props.row.mediaId)
            }
          }
        })])] : undefined
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bf7a353"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MediaLetter.vue
// module id = 966
// module chunks = 1